import { render } from "./TipiChart.vue?vue&type=template&id=2b5d3a10"
import script from "./TipiChart.vue?vue&type=script&lang=js"
export * from "./TipiChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__